import { UPDATE_COCOLOADER_STATE } from "./cocoLoaderStateReducer"

export const updateCocoLoaderState = () => ({
    type: UPDATE_COCOLOADER_STATE,
})